module.exports = __webpack_public_path__ + "95_m7c0XQVxj76Lcf/tandc_icon.svg";